import React from 'react'
import { Form, Grid, Button, Ref, Header, Modal, Input, Confirm, Popup, Label, Message, Segment } from 'semantic-ui-react'
import { connect } from 'react-redux'
import { selectMatch, startMatch, stopMatch } from '../reducers/matches'
import { selectAvailableQuestion, selectQuestionsGameByMatch } from '../reducers/questions'
import { startBet, askQuestion, sendAnswerResults } from '../reducers/questions/actions'
import {startStreaming, stopStreaming} from '../reducers/liveVideoUrl/index'
import {startAutostream, stopAutostream} from '../reducers/autostream/index'
import {enableChat, disableChat, setNumberOfChatters, getNumberOfChatters} from '../reducers/chat/index'
import { restoreGame , deleteSnapshot } from '../reducers/snapshot'
import { deleteTemporaryUser } from '../reducers/users/index'
import QuestionsList from './QuestionsList'
import QuestionsTable from './QuestionsTable'
import { saveMatch } from '../reducers/matches'
import { stopEditMatch } from '../reducers/editMatchId';
import fixModalStyle from '../utils/fixModalStyle'
import throttle from '../utils/throttle'
import { formatDate } from '../utils/formatDate'
import QuizQuestionActions from './QuizQuestionActions'
import NumPlayers from './NumPlayers'
import OnlinePlayers from './OnlinePlayers'
import EditBetSeconds from './EditBetSeconds'
import EditAnswerSeconds from './EditAnswerSeconds'
import ChatChartTabs from './ChatChartTabs'
import Select from 'react-select'
import AgoraRTC from 'agora-rtc-sdk'
import { setUsersLimitNumber, getUsersLimitNumber } from '../reducers/actions'

const customDeviceStyles = {
    width: '300px',
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? 'red' : 'blue',
      padding: 20,
    }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = 'opacity 300ms';
  
      return { ...provided, opacity, transition };
    }
}

const inlineStyleCall = {
    modal : {
      marginTop: '0px !important',
      marginLeft: '150px',
      marginRight: 'auto'
    },
  };

const RemoveQuestionActions = ({ question, onRemoveClick, ...rest }) => (
    <Button.Group {...rest}>
        <Button negative onClick={() => onRemoveClick(question)}>Rimuovi</Button>
    </Button.Group>
)

const ConfirmStopStreamingPopup = ({ stopStreamingPopupOpen, handleStreamingCloseStopPopup, handleStreamingConfirmStop }) => (
    <Confirm open={stopStreamingPopupOpen} 
        style={fixModalStyle}
        header='Finisci Streaming' 
        content='Sei sicuro di voler interrompere lo streaming?'
        onClose={handleStreamingCloseStopPopup}
        onCancel={handleStreamingCloseStopPopup}
        onConfirm={handleStreamingConfirmStop} />
)


class StartStreamingPopup extends React.Component {
    state = { live_video_url : '', error: '' }

    handleError = (error) => {
        this.inputRef.focus()
        this.setState({ error })
    }
    handleInputRef = (ref) => this.inputRef = ref
    handleChangeLiveVideoUrl = (e, { value }) => this.setState({ live_video_url: value, error: '' })
    handleStreamingConfirm = () => {
        const { handleStreamingConfirmStart } = this.props
        const { live_video_url } = this.state
        if (!live_video_url)
            return this.handleError('Devi specificare l\'indirizzo dello streaming live')
            handleStreamingConfirmStart(live_video_url)
    }
 
   render() {
        const { startStreamingPopupOpen, handleStreamingCloseStartPopup, handleAutoStream } = this.props
        const { live_video_url, error } = this.state
        
        return (
            <Modal open={startStreamingPopupOpen}
                style={fixModalStyle}
                onClose={handleStreamingCloseStartPopup}>
                <Modal.Header>Sei sicuro di voler iniziare lo streaming?</Modal.Header>
                <Modal.Content>
                    <p>Qual è l'indirizzo del video live?</p>
                    <Input fluid focus placeholder='e.g. https://youtu.be/a12-b34' 
                        ref={this.handleInputRef}
                        error={!!error}
                        value={live_video_url} 
                        onChange={this.handleChangeLiveVideoUrl} />
                    {!!error ? <Message negative content={error} /> : null}
                </Modal.Content>
                <Modal.Actions>
                    <Button color='purple' onClick={handleAutoStream} >Avvia stream autonomo</Button>
                    <Button negative onClick={handleStreamingCloseStartPopup}>No</Button>
                    <Button positive primary onClick={this.handleStreamingConfirm}>Sì</Button>
                </Modal.Actions>
            </Modal>
        )
    }


}

class StartMatchPopup extends React.Component {
    state = { live_video_url : '', error: '' }

    handleError = (error) => {
        this.inputRef.focus()
        this.setState({ error })
    }
    handleInputRef = (ref) => this.inputRef = ref
    handleChangeLiveVideoUrl = (e, { value }) => this.setState({ live_video_url: value, error: '' })
    
    handleConfirm = () => {
        const { handleConfirmStart, handleStreamingConfirmStart } = this.props
        const { live_video_url } = this.state
        if (!live_video_url && !this.props.live_video_url)
            return this.handleError('Devi specificare l\'indirizzo dello straming live')
        if (this.props.live_video_url){
            handleConfirmStart(this.props.live_video_url)
        } else {
            handleStreamingConfirmStart(live_video_url)
            handleConfirmStart(live_video_url)
        }
        
    }

    render() {
        const { startPopupOpen, handleCloseStartPopup } = this.props
        const { live_video_url, error } = this.state
        
        return (
            <Modal open={startPopupOpen}
                style={fixModalStyle}
                onClose={handleCloseStartPopup}>
                <Modal.Header>Sei sicuro di voler iniziare la partita?</Modal.Header>
                {(this.props.live_video_url === '' || !this.props.live_video_url)?(
                <Modal.Content>
                    <p>Qual è l'indirizzo del video live?</p>
                    <Input fluid focus placeholder='e.g. https://youtu.be/a12-b34' 
                        ref={this.handleInputRef}
                        error={!!error}
                        value={live_video_url} 
                        onChange={this.handleChangeLiveVideoUrl} />
                    {!!error ? <Message negative content={error} /> : null}
                </Modal.Content>):null}
                <Modal.Actions>
                    <Button onClick={handleCloseStartPopup}>No</Button>
                    <Button primary onClick={this.handleConfirm}>Sì</Button>
                </Modal.Actions>
            </Modal>
        )
    }
}


const ConfirmStopPopup = ({ stopPopupOpen, handleClosePopup, handleConfirm }) => (
    <Confirm open={stopPopupOpen} 
        style={fixModalStyle}
        header='Finisci puntata' 
        content='Sei sicuro di voler finire la puntata?'
        onClose={handleClosePopup}
        onCancel={handleClosePopup}
        onConfirm={handleConfirm} />
)

const ConfirmDeleteTemporaryUserPopup= ({ deleteTemporaryUserPopupOpen, handleDeleteTemporaryUserPopup, handleConfirm }) => (
    <Confirm open={deleteTemporaryUserPopupOpen} 
        style={fixModalStyle}
        header='Cancella Utenti Temporanei' 
        content='Sei sicuro di voler cancellare gli utenti temporanei?'
        onClose={handleDeleteTemporaryUserPopup}
        onCancel={handleDeleteTemporaryUserPopup}
        onConfirm={handleConfirm} />
)

const ConfirmDeleteSnapshotUserPopup= ({ deleteSnapshotPopupOpen, handleDeleteSnapshotPopup, handleConfirm }) => (
    <Confirm open={deleteSnapshotPopupOpen} 
        style={fixModalStyle}
        header='Cancella Snapshot' 
        content='Sei sicuro di voler cancellare gli snapshot della partita?'
        onClose={handleDeleteSnapshotPopup}
        onCancel={handleDeleteSnapshotPopup}
        onConfirm={handleConfirm} />
)

const ConfirmRestoreGamePopup= ({ restoreGamePopupOpen, handleRestoreGamePopup, handleConfirm }) => (
    <Confirm open={restoreGamePopupOpen} 
        style={fixModalStyle}
        header='Ripristina la partita' 
        content='Sei sicuro di voler ripristinare la partita?'
        onClose={handleRestoreGamePopup}
        onCancel={handleRestoreGamePopup}
        onConfirm={handleConfirm} />
)

const AddQuestionsPopup = ({ addPopupOpen, questions, matchingQuestions, actualSearchValue, searchValue, handleSearchChange, handleClosePopup, handleAddQuestion }) => (
    <Modal style={fixModalStyle} open={addPopupOpen} onClose={handleClosePopup}>
        <Modal.Header>Aggiungi domande ({questions.length} / 5) {actualSearchValue}</Modal.Header>
        <Modal.Content>
            <Input value={searchValue} onChange={handleSearchChange} icon='search' />
            <div style={{ overflowY: 'auto', maxHeight: '60vh', marginTop: '1em', marginBottom: '1em' }}>
                <QuestionsTable 
                    questions={matchingQuestions}
                    onAddClick={handleAddQuestion} />
            </div>
            <Button onClick={handleClosePopup}>Chiudi</Button>
        </Modal.Content>
    </Modal>
)


class EditMatchForm extends React.Component {
    state = { 
        id: null, 
        date: null, 
        searchValue: '', 
        actualSearchValue: '',
        questions: [],
        question_game: [],
        addPopupOpen: false,
        startPopupOpen: false,
        stopPopupOpen: false,
        startStreamingPopupOpen:false,
        stopStreamingPopupOpen:false,
        deleteTemporaryUserPopupOpen:false,
        deleteSnapshotPopupOpen:false,
        restoreGamePopupOpen:false,
        betSeconds: 10,
        askSeconds: 30,
        streamingOn:false,
        streamingLabel: 'Avvia Streaming',
        chatLabel:'Disattiva Chat',
        restoreLabel:'Ripristina Partita',
        deleteSnapshotLabel:'Svuota Snapshot',
        deleteTemporaryUserLabel:'Cancella Utenti temporanei',
        chatEnabled:true,
        autostreamStarted:false,
        live_video_url: '',
        password: '',
        tempNumberOfChatters:101,
        tempLimitUsersNumber:2001,
        camera: null,
        microphone: null,
        chooseStreamingDeviceOpened: false    
    }

    componentDidMount() {
        if (this.props.onMount)
            this.props.onMount()
        if (this.props.match){
            this.setState(this.props.match)
             // Se il match è finito posso resettare lo streaming video. 
            if (!!this.props.match.ending_time){
                this.setState({live_video_url:''})
            }
        }
        if (this.props.question_game){
            this.setState({question_game:this.props.question_game, questions: this.props.question_game.map(q=>q.question)})
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.match !== this.props.match){
            this.setState(this.props.match)
            if (!!this.props.match.ending_time){
                this.setState({live_video_url:''})
            }  
        }
        if (prevProps.question_game !== this.props.question_game){
            this.setState({  question_game:this.props.question_game , questions: this.props.question_game.map(q=>q.question)})
        }
   
    }

    videoDropDownChange = (option) =>{
        let {value} = option;
        this.setState({camera:value})
    }

    audioDropDownChange = (option) =>{
        let {value} = option;
        this.setState({microphone:value})
    }
    
    deviceClosed = () =>{
        this.setState({chooseStreamingDeviceOpened:false});
    }

    deviceAccepted = () =>{
        this.setState({chooseStreamingDeviceOpened:false, startStreamingPopupOpen:false});
        this.handleConfirmAutoStream();
    }

    

    handleChange = (e, { name, value }) => this.setState({ [name]: value })
    
    handleSearchChange = (e, { value }) => {
        this.setState({ searchValue: value })
        this.search(value)
    }
    search = throttle(text => this.setState({ actualSearchValue: text }), 200)
    
    handleAddQuestion = (question) =>{
        this.setState({ 
         question_game: [...this.state.question_game, 
                        {id:this.props.game_id+ " " +question.id, 
                        question : question,
                        question_id: question.id}], 
    })
    }

    handleRemoveQuestion = (question) => {
        this.setState({
            question_game: this.state.question_game.filter(q=>q.question_id !== question.id),
        })
    }

    handleMoveQuestion = (order) => {
            const orderedQuestionsGame = order.map(
                (question_id) => this.state.question_game.find(question_game => question_game.question_id === question_id)
            )
            this.setState({
                question_game: orderedQuestionsGame
            })
      }
 
    handleStreaming = () =>{
        if (this.state.streamingOn || this.state.autostreamStarted){
            this.setState({stopStreamingPopupOpen:true});        
        }else {
            this.setState({startStreamingPopupOpen:true});
        }
    }

    handleBet = (question) => {
        this.props.onBet({question, seconds: Math.round(this.props.betMs / 1000) })
    }
    handleAsk = (question) => this.props.onAsk({ question, seconds: Math.round(this.props.answerMs / 1000) })
    handleDownloadAnswers = (question) => this.props.onSendResults({question })

    handleAddClick = () => this.setState({ addPopupOpen: true })
    handleClosePopup = () => this.setState({ addPopupOpen: false })
    handlePassword = (e) => {
        this.setState({ password: e.target.value })
    }
    
    handleStartClick = () => this.setState({ startPopupOpen: true })
    handleCloseStartPopup = () => this.setState({ startPopupOpen: false })
   
   
    handleRestoreGamePopupOpen = () => {console.log("APERTO!");this.setState({ restoreGamePopupOpen: true })}
    handleDeleteSnapshotPopupOpen = () => this.setState({ deleteSnapshotPopupOpen: true })
    handleDeleteTemporaryUserPopupOpen = () => this.setState({ deleteTemporaryUserPopupOpen: true })
    handleRestoreGamePopupClose = () => this.setState({ restoreGamePopupOpen: false })
    handleDeleteSnapshotPopupClose = () => this.setState({ deleteSnapshotPopupOpen: false })
    handleDeleteTemporaryUserPopupClose = () => this.setState({ deleteTemporaryUserPopupOpen: false })
    handleConfirmRestoreGame = () => { console.log("RESTORE GAME");this.props.onRestoreGame(); this.setState({ restoreGamePopupOpen: false }) }
    handleConfirmDeleteSnapshot = () => {console.log("DELETE SNAPSHOT");  this.props.onDeleteSnapshot(); this.setState({ deleteSnapshotPopupOpen: false }) }
    handleConfirmDeleteTemporaryUser = () => {  console.log("DELETE TEMPORARY USER"); this.props.onDeleteTemporaryUser(); this.setState({ deleteTemporaryUserPopupOpen: false }) }


    restoreGame = () =>{
        this.props.onRestoreGame();
    }

    deleteSnapshot = () =>{
        this.props.onDeleteSnapshot();
    }

    deleteTemporaryUser = () =>{
        this.props.onDeleteTemporaryUser();
    }

    
    handleConfirmStart = (live_video_url) => { 
        this.props.onMatchStart({ live_video_url, password:this.state.password }); 
        this.setState({ streamingOn:true, streamingLabel:'Ferma Streaming', 
                        startPopupOpen: false, live_video_url:live_video_url }) 
    }



    handleStopClick = () => this.setState({ stopPopupOpen: true })
    handleCloseStopPopup = () => this.setState({ stopPopupOpen: false })
    handleConfirmStop = () => { this.props.onMatchStop(this.state.id); this.setState({ stopPopupOpen: false }) }
    
    

    handleStreamingStartClick = () => this.setState({ startStreamingPopupOpen: true })
    handleStreamingCloseStartPopup = () => this.setState({ startStreamingPopupOpen: false })
    handleStreamingConfirmStart = (live_video_url) => {
         this.props.onStreamingStart({ live_video_url }); 
         this.setState({ streamingOn:true, streamingLabel:'Ferma Streaming', 
                         startStreamingPopupOpen: false, live_video_url: live_video_url}) 
    }
    handleStreamingStopClick = () => this.setState({ stopStreamingPopupOpen: true })
    handleStreamingCloseStopPopup = () => this.setState({ stopStreamingPopupOpen: false })
    handleStreamingConfirmStop = () => { 
        if (this.state.streamingOn)
            this.props.onStreamingStop(); 
        if (this.state.autostreamStarted)
            this.props.onAutoStreamingStop();
        this.setState({ streamingOn:false, streamingLabel:'Avvia Streaming', 
                        stopStreamingPopupOpen: false, live_video_url: '',
                        autostreamStarted:false }) }

    onSubmit = (e) => e.preventDefault()
    onSaveClick = () => {
        this.props.onSubmit({match:this.props.match, questions:this.state.question_game.map(q=>q.question), password:this.state.password})
    }

    handleDownloadChampions = () => {
        var a = document.createElement('a');
        a.href = '/api/winner.xml';
        a.download = 'winner.xml';
        a.click();
    }
            
    handleChat = () =>{
        if (this.state.chatEnabled){
            this.setState({chatLabel:'Attiva Chat', chatEnabled:false})
            this.props.onDisableChat();
        }else {
            this.setState({chatLabel:'Disattiva Chat', chatEnabled:true})
            this.props.onEnableChat();
        }
    }


    

   

    handleDeviceSelection = () =>{
        this.setState({chooseStreamingDeviceOpened:true})
    }

    handleConfirmAutoStream = () =>{
        this.props.onAutoStreamingStart(this.state.camera,this.state.microphone)
        this.setState({streamingLabel:'Ferma Streaming', 
                        startStreamingPopupOpen: false, 
                        autostreamStarted: true }); 
    }

    handleAutoStream = () =>{
        this.handleDeviceSelection();
    }

    changeLimitUsersNumber = (e) =>{
        this.setState({ tempLimitUsersNumber: e.target.value })
    }

    submitLimitUsersNumber = () =>{
        var n = this.state.tempLimitUsersNumber;
        this.setState({tempLimitUsersNumber:n})
        this.props.onHandleLimitUsersNumber(n);
    }

    changeNumChatters = (e) =>{
        this.setState({ tempNumberOfChatters: e.target.value })
    }

    submitNumChatters = () =>{
        var n = this.state.tempNumberOfChatters;
        this.setState({tempNumberOfChatters:n})
        this.props.onHandleNumChatters(n);
    }

    renderStartBtn = ({ isModified, isStarting, isRunning, isEnded }) => {
        const { id, streamingOn, streamingLabel, chatLabel,  chatEnabled, autostreamStarted } = this.state
        const streamOn = streamingOn || autostreamStarted;
        if (!id)
            return null
        if (isModified) 
            return (
                <div>
                <Popup trigger={<span><Button positive disabled >Inizia puntata</Button></span>} content='Devi prima salvare la puntata'/>
                <Button color = {streamOn?'red':'green'} icon = {streamOn?'stop circle outline':'play'} onClick={this.handleStreaming} content = {streamingLabel   }/>
                <Button color = {chatEnabled?'red':'green'} icon = {chatEnabled?'stop circle outline':'play'} onClick={this.handleChat} content = {chatLabel}/>
            </div>
            )
        if (isEnded)
            return (
                <div>
                <Button positive onClick={this.handleStartClick}>Ripeti puntata</Button>
                <Button color = {streamOn?'red':'green'} icon = {streamOn?'stop circle outline':'play'} onClick={this.handleStreaming} content = {streamingLabel}/>
                <Button color = {chatEnabled?'red':'green'} icon = {chatEnabled?'stop circle outline':'play'} onClick={this.handleChat} content = {chatLabel}/>
            </div>
            )
        if (isRunning)
            return (
                <div>
                <Button onClick={this.handleStopClick} >Finisci puntata</Button>
                    <Button  onClick={this.handleDownloadChampions}>Vedi vincitore
                     </Button>
                <Button color = {streamOn?'red':'green'} icon = {streamOn?'stop circle outline':'play'} onClick={this.handleStreaming} content = {streamingLabel}/>
                <Button color = {chatEnabled?'red':'green'} icon = {chatEnabled?'stop circle outline':'play'} onClick={this.handleChat} content = {chatLabel}/>
                </div>
            )
        return (
            <div>
            <Button disabled={isModified || isStarting} positive onClick={this.handleStartClick}>Inizia puntata</Button>
            <Button color = {streamOn?'red':'green'} icon = {streamOn?'stop circle outline':'play'} onClick={this.handleStreaming} content = {streamingLabel}/>
            <Button color = {chatEnabled?'red':'green'} icon = {chatEnabled?'stop circle outline':'play'} onClick={this.handleChat} content = {chatLabel}/>
            </div>
        )
    }

    renderRunningState = (starting_time, ending_time) => {
        if (ending_time)
            return <Label>Andata in onda il {formatDate(starting_time)}</Label>
        if (starting_time)
            return <Label color='green'>In onda</Label>
    }

    getDevices = (audio) =>{
        var res = [];  
        AgoraRTC.getDevices(function (devices) {
          for (var i = 0; i < devices.length; ++i) {
            var device = devices[i];
            if (audio){
                if (device.kind === 'audioinput') {
                    res.push({value:device.deviceId, 
                        key:device.deviceId, 
                              label: device.label || 'microphone ' + (res.length + 1)})
                }
            }else {
                if (device.kind === 'videoinput'){
                    res.push({value:device.deviceId, 
                             key:device.deviceId, 
                             label: device.label || 'camera ' + (res.length + 1)})
                } 
            }
          } 
        });
        return res;
      }
      

    render() {
        const { availableQuestions, onClose, game_id } = this.props
        const { searchValue, actualSearchValue, question_game, addPopupOpen, startPopupOpen, stopPopupOpen, password,
                startStreamingPopupOpen, stopStreamingPopupOpen, isStarting, starting_time, ending_time, live_video_url, chooseStreamingDeviceOpened,
                restoreLabel, deleteSnapshotLabel, deleteTemporaryUserLabel, deleteTemporaryUserPopupOpen, deleteSnapshotPopupOpen,
                restoreGamePopupOpen } = this.state
        const questions = question_game.map(q=>q.question)
        const isModified = (question_game !== this.props.question_game)
        const isEnded = !!ending_time
        const isRunning = !isEnded && !!starting_time

        const questionActions = isRunning ? QuizQuestionActions : RemoveQuestionActions
        const questionCallbacks = isRunning ? 
            { onBet: this.handleBet, onAsk: this.handleAsk, onDownloadAnswers: this.handleDownloadAnswers, onDownloadChampions: this.handleDownloadChampions } : 
            { onRemoveClick: this.handleRemoveQuestion }
        
        const lowerSearchValue = actualSearchValue.toLowerCase().trim()
        const matchingQuestions = availableQuestions
            .filter(q => (q.topic.toLowerCase().indexOf(lowerSearchValue) !== -1 ||
                q.text.toLowerCase().indexOf(lowerSearchValue) !== -1) && 
                    questions.indexOf(q) === -1)
        //disabledOrder = isRunning perchè se la puntata è in onda o finita on voglio poter modificare l'ordine delle domande. 
        const Questions = <QuestionsList game_id = {game_id} question_game = {question_game} actions={questionActions} actionsCallbacks={questionCallbacks}  disableOrder = {isRunning} onMoveQuestion = {this.handleMoveQuestion}/>
        return (
            <Form onSubmit={this.onSubmit}>
                <AddQuestionsPopup 
                    addPopupOpen={addPopupOpen} 
                    questions={questions} 
                    matchingQuestions={matchingQuestions} 
                    actualSearchValue={actualSearchValue} 
                    searchValue={searchValue} 
                    handleSearchChange={this.handleSearchChange} 
                    handleClosePopup={this.handleClosePopup} 
                    handleAddQuestion={this.handleAddQuestion} />
                
                <StartMatchPopup startPopupOpen={startPopupOpen}
                    handleCloseStartPopup={this.handleCloseStartPopup} 
                    handleConfirmStart={this.handleConfirmStart} 
                    live_video_url = {live_video_url}
                    isEnded = {isEnded}
                    handleStreamingConfirmStart = {this.handleStreamingConfirmStart}/>
                {/*<ConfirmStartPopup startPopupOpen={startPopupOpen} 
                    handleCloseStartPopup={this.handleCloseStartPopup} 
                    handleConfirmStart={this.handleConfirmStart} />*/}

                <Modal open={chooseStreamingDeviceOpened} size = 'mini' centered={true} style = {inlineStyleCall.modal}>
                        <Segment>
                            <Grid centered textAlign='center' verticalAlign='middle' padded ={0}>
                                <Grid.Row>
                                <Header>Scegli da dove vuoi streammare</Header> 
                                </Grid.Row>
                                <Grid.Row>
                                <div style={{width: '350px'}}>
                                    <Select
                                        placeholder='Dispositivo video'
                                        fluid
                                        options={this.getDevices(false)}
                                        onChange = {this.videoDropDownChange}
                                        styles={customDeviceStyles}
                                    />
                                </div>
                                </Grid.Row>
                                <Grid.Row>
                                <div style={{width: '350px'}}>
                                <Select
                                        placeholder='Dispositivo audio'
                                        upward fluid
                                        selection
                                        onChange = {this.audioDropDownChange}
                                        options={this.getDevices(true)}
                                        styles={customDeviceStyles}
                                    />
                                </div>
                                </Grid.Row>
                                <Grid.Row>
                                <Button positive enabled={this.state.camera == null || this.state.microphone == null} content='FATTO' fluid  onClick ={this.deviceAccepted}/>
                                </Grid.Row>
                                <Grid.Row>
                                <Button negative content='CHIUDI' fluid onClick ={this.deviceClosed}/>
                                </Grid.Row>
                            </Grid>
                        </Segment>
                    </Modal>


                <ConfirmStopPopup stopPopupOpen={stopPopupOpen}
                    handleClosePopup={this.handleCloseStopPopup}
                    handleConfirm={this.handleConfirmStop} />

                <StartStreamingPopup startStreamingPopupOpen={startStreamingPopupOpen}
                    handleStreamingCloseStartPopup={this.handleStreamingCloseStartPopup} 
                    handleStreamingConfirmStart={this.handleStreamingConfirmStart} 
                    handleAutoStream = {this.handleAutoStream}/>

                <ConfirmStopStreamingPopup stopStreamingPopupOpen={stopStreamingPopupOpen}
                    handleStreamingCloseStopPopup={this.handleStreamingCloseStopPopup}
                    handleStreamingConfirmStop={this.handleStreamingConfirmStop} />
 
                <ConfirmDeleteTemporaryUserPopup deleteTemporaryUserPopupOpen={deleteTemporaryUserPopupOpen}
                    handleDeleteTemporaryUserPopup={this.handleDeleteTemporaryUserPopupClose}
                    handleConfirm={this.handleConfirmDeleteTemporaryUser} />
 
                 <ConfirmDeleteSnapshotUserPopup deleteSnapshotPopupOpen={deleteSnapshotPopupOpen}
                    handleDeleteSnapshotPopup={this.handleDeleteSnapshotPopupClose}
                    handleConfirm={this.handleConfirmDeleteSnapshot} />

                <ConfirmRestoreGamePopup restoreGamePopupOpen={restoreGamePopupOpen}
                    handleRestoreGamePopup={this.handleRestoreGamePopupClose}
                    handleConfirm={this.handleConfirmRestoreGame} />

                {this.renderRunningState(starting_time, ending_time)}
                <Header>Domande ({question_game.length} / 5)</Header>
                <Grid>
                <Grid.Row columns ={2}>    
                    <Grid.Column>
                       <Grid>
                        <Grid.Row style={{paddingTop:'5px', paddingBottom:'5px'}}>
                         {isRunning || isEnded ? null : <Button onClick={this.handleAddClick} primary>Aggiungi domanda</Button>}
                        </Grid.Row>
                        <Grid.Row style={{paddingTop:'5px', paddingBottom:'5px'}}>
                         {this.renderStartBtn({ isModified, isStarting, isRunning, isEnded })}
                        </Grid.Row>
                        <Grid.Row style={{paddingTop:'5px', paddingBottom:'5px'}}>
                        <Button color = {'blue'} icon = {'upload'} onClick={this.handleRestoreGamePopupOpen} content = {restoreLabel}/>
                         <Button color = {'orange'} icon = {'trash'} onClick={this.handleDeleteSnapshotPopupOpen} content = {deleteSnapshotLabel}/>     
                         <Button color = {'purple'} icon = {'bomb'} onClick={this.handleDeleteTemporaryUserPopupOpen} content = {deleteTemporaryUserLabel}/>     
                         </Grid.Row>
                        <Grid.Row style={{paddingTop:'5px', paddingBottom:'5px'}}>
                         <Input action= { <Button color='red' content='Password'/>}
                                                placeholder= {password}   disabled ={ starting_time } onChange ={this.handlePassword} />     
                        </Grid.Row>
                     </Grid>
                        {isRunning ? 
                            <Grid>
                                <Grid.Row style={{paddingTop:'5px', paddingBottom:'5px'}}>
                                   <EditBetSeconds />
                                   <EditAnswerSeconds />
                                </Grid.Row>
                                <Grid.Row style={{paddingTop:'5px', paddingBottom:'5px'}}>
                                    {Questions}
                                </Grid.Row>
                                <Grid.Row style={{paddingTop:'5px', paddingBottom:'5px'}}>
                                <Button onClick={onClose}>Chiudi</Button>
                                </Grid.Row>
                            </Grid>
                        :   
                            <Grid style={{paddingTop:'5px', paddingBottom:'5px'}}>
                                <Grid.Row style={{paddingTop:'5px', paddingBottom:'5px'}}>
                                    {Questions}
                                </Grid.Row>
                                <Grid.Row style={{paddingTop:'5px', paddingBottom:'5px'}}>
                                <Button onClick={onClose}>Chiudi</Button>
                                </Grid.Row>
                            </Grid>
                        }
                    </Grid.Column>
                    <Grid.Column>
                        {isRunning ? 
                        <div>
                        <Grid>
                            <Grid.Row columns={2}>
                                <Grid.Column>
                                <Input action= { <Button color='orange' content='Chatters' onClick={ this.submitNumChatters } />}
                                                placeholder= {this.props.numOfChatters}  onChange ={this.changeNumChatters} style={{width:'180px'}} />        
                                </Grid.Column>
                                <Grid.Column>
                                <Input action= { <Button color='yellow' content='LimiteUtenti' onClick={ this.submitLimitUsersNumber } />}
                                            placeholder= {this.props.usersLimitNumber}  onChange ={this.changeLimitUsersNumber} style={{width:'150px'}}/>                                    
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                             <NumPlayers />
                             <OnlinePlayers />
                             <ChatChartTabs withAnswers canDownload game_id ={game_id} chatEnabled ={true}/>
                        </div>
                        :
                        <div>
                        <Grid>
                            <Grid.Row columns={2}>
                                <Grid.Column>
                                <Input action= { <Button color='orange' content='Chatters' onClick={ this.submitNumChatters } />}
                                                placeholder= {this.props.numOfChatters}  onChange ={this.changeNumChatters} style={{width:'180px'}} />        
                                </Grid.Column>
                                <Grid.Column>
                                <Input action= { <Button color='yellow' content='LimiteUtenti' onClick={ this.submitLimitUsersNumber } />}
                                            placeholder= {2000}  onChange ={this.changeLimitUsersNumber} style={{width:'150px'}}/>                                    
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                            <NumPlayers />
                            <OnlinePlayers />
                            <ChatChartTabs game_id ={null} chatEnabled ={true}/>
                        </div>
                        }
                    </Grid.Column>
                      </Grid.Row>
                <Grid.Row columns ={2}>    
                  {starting_time ? null : <Button type='submit' primary disabled={!isModified} onClick={this.onSaveClick}>Salva</Button>}                   
                </Grid.Row>
                    </Grid>
            </Form>
        )
    }
}


const mapStateToProps = (state, { game_id }) => ({
    // contiene le info sul match o un match vuoto con id "new" se è un match nuovo
    match: selectMatch(state, game_id)||{id:"new"},
    game_id : game_id,
    // contiene la lista di question_game contenute in questo match
    question_game: selectQuestionsGameByMatch(state,game_id),
    // contiene la lista di oggetti Domande disponibili all'inserimento per questo match
    availableQuestions: selectAvailableQuestion(state,game_id),
    betMs: state.betMs,
    answerMs: state.answerMs,
    numOfChatters: state.chat?state.chat.numberOfChatters:1001,
    usersLimitNumber:state.usersLimitNumber.usersLimitNumber?state.usersLimitNumber.usersLimitNumber:1000000
})

const mapDispatchToProps = (dispatch, { socket, game_id }) => ({
    onSubmit: ({match, questions, password}) => { dispatch(saveMatch(socket, match, questions, password));dispatch(stopEditMatch()) },
    onClose: () => dispatch(stopEditMatch()),
    onBet: ({ question, seconds }) => dispatch(startBet(socket, game_id, question, seconds)),
    onAsk: ({question, seconds }) => dispatch(askQuestion(socket, game_id, question, seconds)),
    onSendResults: ({question }) => dispatch(sendAnswerResults(socket, game_id, question.id )),
    onMatchStop: () => dispatch(stopMatch(socket, game_id)),
    onStreamingStop: () => dispatch(stopStreaming(socket)),
    onMatchStart: ({live_video_url, password}) => dispatch(startMatch(socket, game_id, live_video_url, password)), 
    onStreamingStart: ({live_video_url}) => dispatch(startStreaming(socket,live_video_url)),
    onRestoreGame:() => dispatch(restoreGame(socket, game_id)),
    onDeleteSnapshot:() => dispatch(deleteSnapshot(socket, game_id)),
    onDeleteTemporaryUser:() => dispatch(deleteTemporaryUser(socket)),
    onEnableChat:() => dispatch(enableChat(socket)),
    onDisableChat:() => dispatch(disableChat(socket)),
    onAutoStreamingStart: (camera, microphone) => dispatch(startAutostream(socket, camera, microphone)),
    onAutoStreamingStop: () => dispatch(stopAutostream(socket)),
    onHandleNumChatters: (numberOfChatters) => dispatch(setNumberOfChatters(socket,numberOfChatters)),
    onHandleLimitUsersNumber: (usersLimitNumber) => dispatch(setUsersLimitNumber(socket,usersLimitNumber)),
    onMount:() => dispatch(getUsersLimitNumber(socket))
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EditMatchForm)


// WEBPACK FOOTER //
// ./src/components/EditMatchForm.js